<template>
  <div v-if="file">
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_crop"
      size="md"
      ok-only
    >
      <b-overlay :show="cropLoading">
        <vue-cropper
          ref="cropper"
          :Options="3"
          :src="image_to_crop"
          alt="Source Image"
          @zoom="zoom"
          :checkOrientation="false"
          :autoCrop="autoCrop"
          :aspectRatio="aspectRatio"
          :initialAspectRatio="initialAspectRatio"
        >
        </vue-cropper>
        <b-row>
          <b-col v-if="image_to_crop">
            <div class="d-flex justify-content-center style-icon-crop">
              <span
                class="px-3"
                v-b-tooltip.hover
                title="بُرش تصویر"
                @click="initCrop()"
              >
                <i class="fas fa-crop fa-lg cursor-pointer" />
              </span>
              <span
                class="px-3"
                v-b-tooltip.hover
                title="بزرگنمایی"
                @click="zoom(0.1)"
              >
                <i class="fas fa-search-plus fa-lg cursor-pointer" />
              </span>
              <span
                class="px-3"
                v-b-tooltip.hover
                title="کوچک نمایی"
                @click="zoom(-0.1)"
              >
                <i class="fas fa-search-minus fa-lg cursor-pointer" />
              </span>
              <span
                class="px-3"
                v-b-tooltip.hover
                title="چرخش به راست"
                @click="rotate(90)"
              >
                <i class="fas fa-redo fa-lg cursor-pointer" />
              </span>
              <span
                class="px-3"
                v-b-tooltip.hover
                title="چرخش به چپ"
                @click="rotate(-90)"
              >
                <i class="fas fa-undo fa-lg cursor-pointer" />
              </span>
              <span
                class="px-3"
                v-b-tooltip.hover
                title="بازنشانی تغییرات"
                @click="reset()"
              >
                <i class="far fa-times-circle fa-lg cursor-pointer" />
              </span>
            </div>
          </b-col>
        </b-row>
      </b-overlay>
      <template v-slot:modal-footer>
        <div class="float-right">
          <b-button
            v-if="image_to_crop"
            @click="uploadImage"
            class="text-center"
            variant="success"
            :disabled="isCropLoading"
          >
            <div v-if="!isBtnFinal">
              {{ $lang.submitButton }}
              <span key="fa-check"><i class="fa fa-check"></i></span>
            </div>
            <div v-if="isCropLoading">
              <b-spinner small></b-spinner>
              <span> {{ $lang.search.loading_send }}</span>
            </div>
          </b-button>
          <b-button
            @click="deleteImage"
            class="ml-2"
            size="md"
            variant="danger"
          >
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { pathOr } from "ramda";

export default {
  components: {
    VueCropper,
  },
  props: {
    file: {
      type: [Object, File],
    },
    mode: {
      type: String,
      default: "",
    },
    autoCrop: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: Number,
      default: 1 / 1,
    },
    initialAspectRatio: {
      type: Number,
      default: 1 / 1,
    },
  },
  data() {
    return {
      view_crop: false,
      image_to_crop: null,
      cropLoading: false,
      isBtnFinal: false,
      isCropLoading: false,
    };
  },
  methods: {
    pathOr,
    zoom(index) {
      this.$refs.cropper.relativeZoom(index);
    },
    rotate(direction) {
      this.$refs.cropper.rotate(direction);
    },
    reset() {
      try {
        this.$refs.cropper.reset();
        this.$refs.cropper.clear();
        this.$refs.cropper.clearCrop();
        this.initCrop();
      } catch (error) {
        //
      }
    },
    initCrop() {
      this.$refs.cropper.initCrop();
    },
    cropImage({ coordinates, canvas }) {
      this.coordinates = coordinates;
      this.image_dispay = canvas.toDataURL();
    },
    dataURLtoFile(dataUrl, fileName) {
      let arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], fileName, { type: mime });
    },
    async uploadImage() {
      try {
        this.cropLoading = true;

        /* await this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          let image = new File([blob], this.file.name, {
            type: this.file.type,
          });
          let id = this.file.id ? this.file.id : null;
          let payload = {
            id: id,
            img: image,
            attachment_type_id:
              this.file.attachment_type && this.file.attachment_type.id,
          };
          this.$emit("save", payload);
        }); */
        const base64Image = await this.$refs.cropper
          .getCroppedCanvas()
          .toDataURL("image/jpeg", 0.9);
        const image = this.dataURLtoFile(base64Image, this.file.name);
        let id = this.file.id ? this.file.id : null;
        let payload = {
          id: id,
          img: image,
          attachment_type_id: pathOr(
            null,
            ["attachment_type", "id"],
            this.file
          ),
          code: pathOr(null, ["code"], this.file),
        };
        this.$emit("save", payload);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.cropLoading = false;
        this.view_crop = false;
      }
    },
    deleteImage() {
      this.view_crop = false;
      this.$emit("clearValue");
    },
  },
  watch: {
    file() {
      if (this.file) {
        if (this.mode == "priview") {
          this.image_to_crop = this.file.url;
        } else {
          this.image_to_crop = URL.createObjectURL(this.file);
        }
      }
    },
  },
};
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}

.style-icon-crop {
  background: #676767b8;
  padding: 10px 0;
  color: white;
}
</style>
